import { useMutation } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IGetTrayNameListData } from '../../../types';

/**
 * This is to track the archive Inbound mutation keys in react query cache.
 */
const MUTATE_GENERATE_TRAY_NAME_LIST = 'generate-tray-name-list-mutation-key';

interface IUseArchiveInboundMutation {
  onSuccessCallback: (data: IGetTrayNameListData) => void;
}

/**
 * React Query mutation function for archiving an Inbound Transaction
 */
export const useNewTrayListMutation = ({
  onSuccessCallback,
}: IUseArchiveInboundMutation) => {
  const { data, error, isError, isPending, mutate, reset } = useMutation({
    mutationKey: [MUTATE_GENERATE_TRAY_NAME_LIST],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.generateNewTrayNameList,
    onSuccess: onSuccessCallback,
  });

  return {
    mutate,
    data,
    error,
    isError,
    isPending,
    reset,
  };
};
